import { useEffect } from "react";
import { useLazyGetFileByObjectIdAndTypeQuery } from "../../../../../redux/api/FileApi";
import { useAppSelector } from "../../../../../redux/Hooks";
import ConfirmModal from "../../../../common/components/ConfirmModal";
import { exportFile } from "../../../../common/ts/CommonFunctions";
import { fileTypes } from "../../../../common/types/types";

interface Props {
    denyVisible: boolean,
    toggleDenyVisible: () => void,
    note?: string,
    bidderId: number,
    otherUser?: boolean,
    bidderCode?: string,
}

const DenyRightsModal = ({ denyVisible, toggleDenyVisible, note, bidderId, otherUser = false, bidderCode }: Props) => {
    const auctionState = useAppSelector(state => state.auction);
    const [fileTrigger, fileResponse] = useLazyGetFileByObjectIdAndTypeQuery();

    useEffect(() => {
        fileTrigger({ objectId: bidderId, objectType: fileTypes.AUCTION_DECLINE_REASON })
    }, [fileTrigger, bidderId])

    const downloadFile = (id: number, fileName: string) => {
        let url = process.env.REACT_APP_API_URL + `/files/downloadFile/${id}`;
        exportFile(url, fileName);
    }

    return (
        <ConfirmModal
            noCancelButton
            visible={denyVisible}
            onCancel={toggleDenyVisible}
            onOk={toggleDenyVisible}
            status="error"
            title={<>
                {otherUser ?
                    <div>Truất quyền đối với Người tham gia đấu giá: {bidderCode}</div> :
                    <div>Bạn đã bị truất quyền đấu giá!</div>}
                <div>Lý do truất quyền: {note || (auctionState.skippedRound && !otherUser ? "Không trả giá vòng trước đó." : "")}</div>
                {fileResponse.data?.length ?
                    <div className="text-overflow-custom-one-line">File đính kèm: <span className="anchor-text" onClick={() => downloadFile(fileResponse.data?.[0].attachmentId || 0, fileResponse.data?.[0].fileName || "")}>{fileResponse.data?.[0]?.fileName}</span></div>
                    : <></>}
            </>}
        />
    )
}

export default DenyRightsModal;